import React from 'react';
import PropTypes from 'prop-types';
import { health } from '../services/core-data'

class HealthLoader extends React.Component {

  state = {
    loaded: false,
    error: false
  };

  async tryLoadHealth(attempt = 0) {
    try {
      await health();
    } catch(e) {
      console.warn('Error loading health', e);
      if (attempt > 5) {
        throw e;
      }
      await new Promise(resolve => setTimeout(resolve, (attempt + 1) * 50));
      return this.tryLoadHealth(attempt + 1);
    }
  }

  componentWillMount() {
    const start = Date.now();
    this.tryLoadHealth()
      .then(() => {
        // Complete the current animation, let it run till the end of the flip
        const difference = Date.now() - start;
        const remaining = 3000 - (((difference / 3000) - Math.floor(difference / 3000)) * 3000);
        if (remaining < 0) {
          return;
        }
        return new Promise(resolve => setTimeout(resolve, remaining));
      })
      .then(() => new Promise(resolve => this.setState({
        loaded: true
      }, resolve)))
      .catch((error) => {
        console.warn(error);
        return new Promise(resolve => this.setState({
          error: true
        }, resolve))
      })
  }

  render() {
    if (this.state.loaded) {
      return this.props.children(this.props);
    }
    return (
      <div className={`health-loading ${this.state.error ? 'health-loading-message' : 'coin-flip'}`}>
        {this.state.error ? 'Error occurred, please contact system support' : (
          <React.Fragment>
            <div className="coin-tails">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/US_One_Cent_Rev.png/240px-US_One_Cent_Rev.png" />
            </div>
            <div className="coin-heads">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/US_One_Cent_Obv.png/240px-US_One_Cent_Obv.png" />
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

HealthLoader.propTypes = {
  children: PropTypes.func.isRequired
};

export default HealthLoader;


// WEBPACK FOOTER //
// ./src/app/health-loader.js